/**
 * Facts the legal pages share. One place, so a change of address or date is one edit.
 *
 * The contact address follows the site's own hostname rather than being written in, so
 * the pages stay correct if the domain changes (issue #101).
 */
export const ENTITY = 'Kazpero Ltd'

/** The registered office. */
export const ENTITY_ADDRESS = '50 Princes Street, Ipswich, IP1 1RJ, England'

/** Companies House number; a company must show it on its website. */
export const COMPANY_NUMBER = '16867354'

/** Bump when either page changes in substance. */
export const LEGAL_UPDATED = '18 October 2026'

export function supportEmail(hostname: string = window.location.hostname): string {
  return `support@${hostname}`
}
